import React, { useState } from 'react';
import visityLogo from "./resources/LogoBlue.png";
import visityHome from "./resources/visity_main.PNG";
import foodxHome from "./resources/foodx_main.PNG";
import foodxPlan from "./resources/foodx_main2.PNG";

import vretta from '../../resource/Art/vretta.PNG';
import echo from '../../resource/Art/echo.PNG';
import visity from '../../resource/Art/visity.PNG';
import qcri from '../../resource/Art/qcri.PNG';
import japan from '../../resource/Art/japan.PNG';

// Functional Component
const WebDev = () => {
  return (
    <div style={{
      letterSpacing: "3px",
      fontSize: "1.3em",
      padding: "0em 1em",
    }} className="webDevContent">

      <div style={{
        color: "black",
        marginRight: "1em",
        paddingTop: ".5em",
        textAlign: "left",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
      }}>
        <div className='secondBubble mainTitle'>
          <b>5 years of professional experience</b> under my belt supporting over <b>1.3 million students</b> across Canada! <b>Revolutionizing</b> their <b>educational experiences</b>.
        </div>

        <img src={vretta} className="vretta" />
        <div className='currentJob'>
          <div className='currentJSection'>
            Started as a <b>front-end developer</b> back in 2021 with Vretta
          </div>
          <div className='currentJSection'>
            Then, kept learning and expanding into a <b>full-stack developer</b> role by 2022, and then into
          </div>
          <div>
            a <b>lead developer</b> by 2024 with central responsibilities guiding various products.
          </div>
        </div>

        <div className='dividerNote'>
          Even before my professional entry into the industry, my eagerness to learn have led to a handful of interesting <b>personal projects.</b>
        </div>
        <div className='bubbleWrapper'>
          <div className='twinBubble'>
            <div className='personalBubble blackbubble'>
              <div>
                <img src={visity} className="visity bubbleTitle" /><br></br>
                Was a <b>travel agency</b> project where <b>travelers</b> and <b>locals</b> swipe on each other’s profiles for <b>authentic experiences</b> and <b>supporting local businesses.</b>
              </div>
            </div>
            <div className='personalBubble whiteBubble'>
              <div>
                <img src={echo} className="echo bubbleTitle" /><br></br>
                Was an <b>audio-based social medial</b> project where the main point of accessibility <b>centers the visually impaired.</b>
              </div>
            </div>
          </div>

          <div className='twinBubble'>
            <div className='personalBubble blackbubble'>
              <div>
                <img src={qcri} className="qcri bubbleTitle" /><br></br>
                My <b>internship</b> when I was a student at the <b>College of North Atlantic-Qatar</b>. Where i worked on <b>Machine Learning</b> algorithm for crime predictions.
              </div>
            </div>
            <div className='personalBubble whiteBubble'>
              <div>
                <img src={japan} className="japan bubbleTitle" /><br></br>
                An honorable mention is <b>my japan tourism website</b> which i worked on in <b>an early class</b> in my journey.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebDev;